import { render, staticRenderFns } from "./koiRaffleData.vue?vue&type=template&id=37c9b2e8&scoped=true"
import script from "./koiRaffleData.vue?vue&type=script&lang=ts"
export * from "./koiRaffleData.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c9b2e8",
  null
  
)

export default component.exports